<template>
  <div class="content">
    <div class="table-page-operator-wrapper action-btn" >
      <a-button @click="handleTemplate" v-hasPermi="['scp:scpMpsOrderFulfillmentRate:template']">下载模版</a-button>
      <a-button @click="$refs.importData.show()" type="primary" v-hasPermi="['scp:scpMpsOrderFulfillmentRate:import']"
      >导入</a-button
      >
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:scpMpsOrderFulfillmentRate:export']"
      >导出</a-button
      >
    </div>
    <a-spin :spinning="isLoading">
      <ls-api-table
        class="table"
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        rowKey="id"
        :scroll="{ fixScreen: true, x: 1300 }"
      >
        <template slot="minOrderFulfillmentRate" slot-scope="{ record }">
          <span v-if="!isEdit || currentId !== record.id">{{ record.minOrderFulfillmentRate+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.id"
            v-model="record.minOrderFulfillmentRate"
            size="small"
          />
        </template>
        <template slot="triggerOrderFulfillmentRate" slot-scope="{ record }">
          <span v-if="!isEdit || currentId !== record.id">{{ record.triggerOrderFulfillmentRate+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.id"
            v-model="record.triggerOrderFulfillmentRate"
            size="small"
          />
        </template>
        <template slot="rangeShow" slot-scope="{ record }">
          <span>{{ `(${record.rangeFrom} - ${record.rangeTo}]` }}</span>
        </template>
        <template slot="updateTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="createTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="versionCode" slot-scope="{ record }">
          <a @click="handleGoVersion(record)" class="ml10">{{ record.versionCode }}</a>
        </template>
        <!-- 月份 -->
        <template slot="month" slot-scope="{ record, column }">
          <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex].initialDeliveryRatio+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.id"
            v-model="record[column.dataIndex].initialDeliveryRatio"
            size="small"
          />
          <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
        </template>
        <!-- 操作 -->
        <span slot="operation" slot-scope="{ record, $index }">
          <a
            v-if="!isEdit || currentId !== record.id"
            @click="handleEdit(record, $index)"
            v-hasPermi="['scp:scpMpsOrderFulfillmentRate:edit']"
          >编辑</a
          >
          <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDelete(typeList, record)" v-hasPermi="['scp:scpMpsOrderFulfillmentRate:remove']">删除</a>
          <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
          <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
        </span>
      </ls-api-table>
    </a-spin>
    <import-data
      ref="importData"
      :url="url"
      :mpsBasicDataId="queryParams.mpsBasicDataId"
      @handle-success="handleOk"
    />
  </div>
</template>

    <script>

  import { generateLsTableResData } from '@/utils/util.js'
  import ImportData from './ImportData'
  import { apiScpMpsOrderFulfillmentRate, apiUpdateScpMpsOrderFulfillmentRate, apiDeleteScpMpsOrderFulfillmentRate } from '@/api/mps/basic-data/basic-data.js'

  export default {
    components: {
      ImportData
      },
    props: {
      id: {
        type: String,
        default: '' // 设置默认值为'Hello from child'
      },
      scpProductBroadCategory: {
        type: String,
        default: '' // 设置默认值为'Hello from child'
      },
      itemId: {
        type: String,
        default: '' // 设置默认值为'Hello from child'
      }
    },
    data () {
      const id = this.id
      const scpProductBroadCategory = this.scpProductBroadCategory
      const itemId = this.itemId
      return {
        isLoading: false,
        url: '/scp/scpMpsOrderFulfillmentRate/import',
        isEdit: false,
        tableList: [],
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiScpMpsOrderFulfillmentRate, true),
          pageCurrent: true
        },
        columnsServe: [],
        // 表格字段
        columns: [
          // {
          //   title: '版本',
          //   dataIndex: 'versionCode',
          //   width: 180,
          //   align: 'center'
          // },
          {
            title: '工艺大类',
            dataIndex: 'scpProductBroadCategoryDesc',
            width: 120,
            align: 'center'
          },
          {
            title: '物料编码',
            dataIndex: 'itemCode',
            width: 150,
            align: 'center'
          },
          {
            title: '区间范围',
            dataIndex: 'rangeShow',
            scopedSlots: { customRender: 'rangeShow' },
            width: 180,
            align: 'center'
          },
          {
            title: '触发订单满足率',
            dataIndex: 'triggerOrderFulfillmentRate',
            scopedSlots: { customRender: 'triggerOrderFulfillmentRate' },
            width: 180,
            align: 'center'
          },
          {
            title: '最小订单满足率',
            dataIndex: 'minOrderFulfillmentRate',
            scopedSlots: { customRender: 'minOrderFulfillmentRate' },
            width: 180,
            align: 'center'
          },
          {
            title: '最后修改人',
            dataIndex: 'updateName',
            width: 120,
            align: 'center'
          },
          {
            title: '最后修改时间',
            dataIndex: 'updateTime',
            scopedSlots: { customRender: 'updateTime' },
            width: 180,
            align: 'center'
          },
          {
            title: '操作',
            fixed: 'right',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 120,
            align: 'center'
          }
        ],
        queryParams: {
          mpsBasicDataId: id,
          scpProductBroadCategory: scpProductBroadCategory,
          itemId: itemId
        }
      }
    },
    methods: {
        /** 下载模板操作 */
        handleTemplate () {
        this.download('scp/scpMpsOrderFulfillmentRate/template', {
        }, `订单满足率导入模板_${new Date().getTime()}.xlsx`)
      },
          // 接口请求成功后回调
          successCallBack (myDataSource) {
            // debugger
          },
          /** 导出按钮操作 */
     handleExport () {
        this.download('scp/scpMpsOrderFulfillmentRate/export', {
          mpsBasicDataId: this.queryParams.mpsBasicDataId
        }, `订单满足率列表_${new Date().getTime()}.xlsx`)
      },
     // 新增/修改框事件
       handleOk () {
           this.onSearch()
        },
      handleDelete (tableList, record) {
        // debugger
        const self = this
        this.$confirm({
          title: '警告',
          content: `真的要删除该项的数据项吗?`,
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            // const ids = []
            // self.columnsServe.forEach((column) => {
            //   console.log(column.indexKey)
            //   const id = record[column.indexKey].id
            //   ids.push(id)
            // })
            apiDeleteScpMpsOrderFulfillmentRate(record.id).then((response) => {
              if (response.code === 200) {
                self.$message.success('删除成功')
                self.onSearch()
              } else {
                self.$message.error(response.msg)
              }
            })
          }
        })
      },
      // 编辑-保存
      handleSave (record) {
        if (record.minOrderFulfillmentRate < 0) {
        this.$message.warning('最小订单满足率必须大于等于0')
        return
      }
      if (record.triggerOrderFulfillmentRate < 0) {
        this.$message.warning('触发订单满足率必须大于等于0')
        return
      }
        const recordCopy = JSON.parse(JSON.stringify(record))
        apiUpdateScpMpsOrderFulfillmentRate(recordCopy).then((response) => {
          if (response.code === 200) {
            this.$message.success('更新成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 表单搜索
      onSearch (scpProductBroadCategory, itemId, mpsBasicDataId) {
        this.isEdit = false
        console.log("输出工艺大类：" + scpProductBroadCategory);
        this.queryParams.scpProductBroadCategory = scpProductBroadCategory;
        this.queryParams.itemId = itemId;
        if (mpsBasicDataId) {
          this.queryParams.mpsBasicDataId = mpsBasicDataId;
        }
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
        // this.$refs.dataTable.myPagination.current = 1
        // this.getTableInfo({ sopDfcBasicDataId: this.id, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
      },
      // 编辑
      handleEdit (record, index) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return
        }
        this.isEdit = true
        this.currentId = record.id
      }
    },
    created () {
    },
    mounted () {
      this.onSearch()
    }
  }
  </script>

  <style scoped lang="less">
  .content {
    display: flex;
    flex-direction: column;
  }
  .action-btn {
    display: flex;
    padding: 8px;
  }
  .table {
    flex: 1;
  }
  </style>
